export default __webpack_public_path__ + "static/media/learn_bg_top_left.e98f7d9a.png";